const SCROLL_TOP_THRESHOLD = 30 // px

const isTop = () => window.scrollY < SCROLL_TOP_THRESHOLD
export default isTop
